<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../../_common/z/ztab.svelte'
    import SitesConfig from './sites-config.svelte'
    import SitesAppearance from './sites-appearance.svelte'

    let tabs = [
        {
            title: 'Meu aplicativo',
            url: '/tools-app/config',
        },
        {
            title: 'Aparência',
            url: '/tools-app/appearance',
        },
    ]
</script>

<div class="limit-1600 p-2">
    <Ztab class="h-space" {tabs} />
    <Router>
        <Route path="/config">
            <SitesConfig />
        </Route>
        <Route path="/appearance">
            <SitesAppearance />
        </Route>
    </Router>
    <div class="m-bottom-sm" />
</div>
